import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

import { ref } from 'vue';

import { createStyle } from '@v1/composables/create-style';
import { StyleExtender } from '@v1/composables/style-extender';
import { useTruncateStyle } from '@v1/composables/use-styles';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseHeader',
  props: {
  disableTruncate: {
    type: Boolean,
    required: false,
    default: false,
  },
  styleExtension: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  asReactive: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const styleExtender = new StyleExtender({ variablePrefix: '--v1-base-header' });

const props = __props;

const truncateStyle = ref(useTruncateStyle());

const style = createStyle({
  container: {},
}, {
  asReactive: props.asReactive,
});

styleExtender.extend({
  target: style.container,
  extension: props.styleExtension.container,
  selector: 'container',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    class: _ctx.$style.container,
    style: _unref(style).container
  }), [
    (__props.disableTruncate)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle(truncateStyle.value)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 4))
  ], 16))
}
}

})